import React, { useReducer, useEffect, useMemo } from 'react';
import { Routes, Route, useNavigate } from 'react-router-dom';
import { CSSTransition } from 'react-transition-group';
import './App.css';
import coininfo from 'coininfo';
import { Top } from 'TopUI';
import {
  UserRegistrationPopup,
  ReadMnemonicForRegistrationPopup,
  ReadWifForRegistrationPopup,
} from 'UserRegistration';
import { RegistrationAndAgreementListPopup } from 'LoginUI';
import { BuildDeck } from 'BuildDeckUI';
import {
  Duel,
  DeckOnDuelSP,
  DuelSettingsPopup,
} from 'DuelUI';
import {
  DuelHistory,
  DuelHistoryDetailFullScreen,
  DuelHistoryDetail,
  DeckInHistorySP,
} from 'DuelHistoryUI';
import { DuelRanking } from 'DuelRankingUI';
import { CardList } from 'CardListUI';
import { CardRegistration } from 'CardRegistrationUI';
import { PlayerStats } from 'PlayerStatsUI';
import { ChargePoint, PointRecordDetail } from 'MonatokaPointUI';
import { LiveText } from 'PublicDisplayUI';
import { Retailer } from 'RetailerUI';
import {
  PurchaseItem,
  MerchandiseDetail,
  CheckOut,
  ItemOrderHistory,
  ItemOrderHistoryRecordDetail,
} from 'PurchaseItemUI';
import { Setting } from 'SettingKOM';
import { NfcCallback } from 'SettingAll';
import {
  ItemDetailSP,
  MonsterDetail,
  CreatorInformation,
  DuelSettingsButton,
} from 'MonadomCoreUI';
import { ConfirmMnemonicPopup } from 'KeyBox';
import {
  MnemonicInputPopup,
  SelectSessionPopup,
  SelectSubAddressPopup,
  SelectAddressFromKeypoolPopup,
  SelectSecretPopup,
  WifInputPopup,
  DisplayWifPopup,
 } from 'KeysAndSigningUI';
import {
  QrCodeScannerPopup,
  QrCodeReaderPopup,
  DisplayQrPopup,
  ConfirmationPopup,
} from 'UtilComponents';
import { AboutKnightsOfMonadom } from 'AboutKnightsOfMonadomUI';
import {
  ensureUnlockAudio,
} from './audioPlayer';
import { GlobalStateCS, useGlobalStateSelector, words } from './globalState';
import {
  buildUserWithCollectibleWordsFromBattleUp,
  buildCollectibleWordSoundEffectNamesInBattle,
  buildCollectibleWordSoundEffectNamesInDuel,
} from './duel';
import {
  handleClickChallengeDuel,
} from './monadomCore';
import {
  getCompositeRecordFromIndexedDb,
  initialWalletType,
} from 'utils';
import {
  decimalAdjust,
} from 'utils/utilsMisc';
import { hasCamera } from 'utils/utilsBrowser';
import { devLog } from 'dev/development';
import { syncHttpRequest2 } from 'utils/http';

let wallet;


// AppConnect対応
// porting nodejs EventEmitter
const EventEmitter=function(){
  function EventEmitter(){
    this._events=this._events||{};
    this._maxListeners=this._maxListeners||undefined
  }

  EventEmitter.EventEmitter=EventEmitter;
  EventEmitter.prototype._events=undefined;
  EventEmitter.prototype._maxListeners=undefined;
  EventEmitter.defaultMaxListeners=10;

  EventEmitter.prototype.setMaxListeners=function(n){
    if(!isNumber(n)||n<0||isNaN(n))
      throw TypeError("n must be a positive number");

    this._maxListeners=n;
    return this
  };

  EventEmitter.prototype.emit=function(type){
    var er,handler,len,args,i,listeners;
    if(!this._events)
      this._events={};
    if(type==="error"){
      if(!this._events.error||isObject(this._events.error)&&!this._events.error.length){
        er=arguments[1];

        if(er instanceof Error){
          throw er
        }
        else{
          var err=new Error('Uncaught, unspecified "error" event. ('+er+")");
          err.context=er;
          throw err
        }
      }
    }

    handler=this._events[type];

    if(isUndefined(handler))
      return false;

    if(isFunction(handler)){
      switch(arguments.length){
        case 1:
          handler.call(this);
          break;
        case 2:
          handler.call(this,arguments[1]);
          break;
        case 3:
          handler.call(this,arguments[1],arguments[2]);
          break;
        default:args=Array.prototype.slice.call(arguments,1);
          handler.apply(this,args)
      }
    }
    else if(isObject(handler)){
      args=Array.prototype.slice.call(arguments,1);
      listeners=handler.slice();
      len=listeners.length;
      for(i=0;i<len;i++)
        listeners[i].apply(this,args)
    }

    return true
  };

  EventEmitter.prototype.addListener=function(type,listener){
    var m;

    if(!isFunction(listener))
      throw TypeError("listener must be a function");

    if(!this._events)
      this._events={};

    if(this._events.newListener)
      this.emit("newListener",type,isFunction(listener.listener)?listener.listener:listener);

    if(!this._events[type])
      this._events[type]=listener;
    else if(isObject(this._events[type]))
      this._events[type].push(listener);
    else
      this._events[type]=[this._events[type],listener];

    if(isObject(this._events[type])&&!this._events[type].warned){
      if(!isUndefined(this._maxListeners)){
        m=this._maxListeners
      }
      else{
        m=EventEmitter.defaultMaxListeners
      }
      if(m&&m>0&&this._events[type].length>m){
        this._events[type].warned=true;
        console.error("(node) warning: possible EventEmitter memory leak detected. %d listeners added. Use emitter.setMaxListeners() to increase limit.",this._events[type].length);

        if(typeof console.trace==="function"){
          console.trace()
        }
      }
    }

    return this
  };

  EventEmitter.prototype.on=EventEmitter.prototype.addListener;
  EventEmitter.prototype.once=function(type,listener){
    if(!isFunction(listener))
      throw TypeError("listener must be a function");

    var fired=false;

    function g(){
      this.removeListener(type,g);

      if(!fired){
        fired=true;
        listener.apply(this,arguments)
      }
    }

    g.listener=listener;
    this.on(type,g);
    return this
  };

  EventEmitter.prototype.removeListener=function(type,listener){
    var list,position,length,i;

    if(!isFunction(listener))
      throw TypeError("listener must be a function");

    if(!this._events||!this._events[type])
      return this;

    list=this._events[type];
    length=list.length;
    position=-1;

    if(list===listener||isFunction(list.listener)&&list.listener===listener){
      delete this._events[type];
      if(this._events.removeListener)this.emit("removeListener",type,listener)
    }
    else if(isObject(list)){
      for(i=length;i-- >0;){
        if(list[i]===listener||list[i].listener&&list[i].listener===listener){
          position=i;
          break
        }
      }

      if(position<0)
        return this;

      if(list.length===1){
        list.length=0;
        delete this._events[type]
      }
      else{
        list.splice(position,1)
      }

      if(this._events.removeListener)
        this.emit("removeListener",type,listener)
    }

    return this
  };

  EventEmitter.prototype.removeAllListeners=function(type){
    var key,listeners;
    if(!this._events)
      return this;

    if(!this._events.removeListener){
      if(arguments.length===0)
        this._events={};
      else if(this._events[type])
        delete this._events[type];

      return this
    }

    if(arguments.length===0){
      for(key in this._events){
        if(key==="removeListener")
          continue;

        this.removeAllListeners(key)
      }

      this.removeAllListeners("removeListener");
      this._events={};
      return this
    }

    listeners=this._events[type];

    if(isFunction(listeners)){
      this.removeListener(type,listeners)
    }
    else if(listeners){
      while(listeners.length)
        this.removeListener(type,listeners[listeners.length-1])
    }

    delete this._events[type];
    return this
  };

  EventEmitter.prototype.listeners=function(type){
    var ret;

    if(!this._events||!this._events[type])
      ret=[];
    else if(isFunction(this._events[type]))
      ret=[this._events[type]];
    else
      ret=this._events[type].slice();

    return ret
  };

  EventEmitter.prototype.listenerCount=function(type){
    if(this._events){
      var evlistener=this._events[type];

      if(isFunction(evlistener))
        return 1;
      else if(evlistener)
        return evlistener.length
    }
    return 0
  };

  EventEmitter.listenerCount=function(emitter,type){
    return emitter.listenerCount(type)
  };

  function isFunction(arg){
    return typeof arg==="function"
  }

  function isNumber(arg){
    return typeof arg==="number"
  }

  function isObject(arg){
    return typeof arg==="object"&&arg!==null
  }

  function isUndefined(arg){
    return arg===void 0
  }

  return EventEmitter
}();

const ORIGIN = 'https://monapalette.komikikaku.com';
const SUPPORTED_METHODS = ['getAddress', 'sendAsset', 'signRawTransaction', 'signMessage', 'sendRawTransaction', 'counterBlock', 'counterParty'];
const monapaletteConnect = {};
const id2messageListener = {};
const sendMethod = async(method, params) => {
    if (!window.parent) throw new Error('AppConnect not found');
    const id = Math.random().toFixed(10).slice(-10);
    return await new Promise((resolve, reject) => {
        id2messageListener[id] = (event) => {
            try {
                if (event.origin !== ORIGIN) return;
                const data = event.data;
                if (data.id !== id) return;
                delete id2messageListener[id];
                if (data.error) reject(data.error);
                else resolve(data.value);
            }
            catch (error) { reject(error) }
        };
        window.parent.postMessage({ id, method, params }, ORIGIN);
    });
};
for (const method of SUPPORTED_METHODS) monapaletteConnect[method] = (...params) => sendMethod(method, params);
monapaletteConnect.updateEmitter = new EventEmitter();
window.monapaletteConnect = monapaletteConnect;
window.addEventListener('message', (event) => {
    for (const id in id2messageListener) id2messageListener[id](event);
});

// console.log('ancestor', window.location.ancestorOrigins[0]);

if (window.location.ancestorOrigins !== undefined && window.location.ancestorOrigins[0] === ORIGIN) {
  wallet = 'MonaPallet';
}
else {
  wallet = 'Mpurse';
  // wallet = 'MonaPallet';
}


// APP
function App() {
  const urlParams = (new URL(document.location)).searchParams;

  // 検索期間のデフォルト値
  const now = new Date();
  // let yearLastMonth;
  // let monthLastMonth;
  // let dayEndLastMonth;

  if (now.getMonth() === 0) {
    // yearLastMonth = now.getFullYear() - 1;
    // monthLastMonth = 12;
  }
  else {
    // yearLastMonth = now.getFullYear();
    // monthLastMonth = now.getMonth();
  }

  if (now.getMonth() === 4 || now.getMonth() === 6 || now.getMonth() === 9 || now.getMonth() === 11) {
    // dayEndLastMonth = 30;
  }
  else if (now.getMonth() === 2) {
    if (now.getFullYear() % 4 === 0) {
      // dayEndLastMonth = 29;
    }
    else {
      // dayEndLastMonth = 28;
    }
  }
  else {
    // dayEndLastMonth = 31;
  }


  const initialState = {
    networkMona: coininfo('MONA').toBitcoinJS(),
    language: urlParams.get('language') === null ? 'japanese' : urlParams.get('language'),
    marginOfSessionTime: 60000,
    device: {
      hasCamera: undefined,
    },
    config: {
      clientParameters: {
        versionOfTheTermsAndConditions: 'dummy',
        versionOfPrivacyPolicy: 'dummy',
      },
    },
    configMP: {
      clientParameters: {
      },
    },
    configKB: {
      clientParameters: {
      },
    },
    login: {
      addressMain: '',
      displayAddressSection: false,
    },
    configure: {
      addressMain: '',
      displayAddressSection: false,
      userName: '',
      // images: {
      //   main: null,
      // },
      // imagesNew: {
      //   main: null,
      //   mainUrl: null,
      // },
      readTheTermsAndConditions: false,
      readPrivacyPolicy: false,
      acceptedVersionOfTheTermsAndConditions: null,
      acceptedVersionOfPrivacyPolicy: null,
      // profileText: '',
      mnemonic: null,
      wif: '',
      status: null,
    },
    active: {
      addressMain: undefined,
      parent: null,
    },
    balance: {
    },
    webSocketContainer: {
      webSocket: undefined,
      status: null,
    },
    websocket: {
      status: 'close',
    },
    webSocketToBroadcastContainer: {
      webSocket: undefined,
    },
    duel: {
      visible: false,
      textCount: 0,
      text: '',
      chunks: [],
      straightManChunks: [],
      round: 0,
      myStatus: null,
      action: undefined,
      actionOpponent: undefined,
      pointA: 0,
      pointB: 0,
      winner: undefined,
      winningMonster: undefined,
      winningMonsterIndex: undefined,
      duelWinner: undefined,
      monstersInformation: undefined,
      monstersInformationRevised: undefined,
      monstersIndex: undefined,
      result: [],
      collectibleWordSoundEffectNamesInDuel: [],
      collectibleWordSoundEffectNamesInBattle: [],
      prefield: undefined,
      maginaPoint: {
        A: 0,
        B: 0,
        applied: {
          point: 0,
          side: null,
        }
      },
      timeOutTime: undefined,
      status: undefined,
      basicInformation: undefined,
      castMagics: [],
      magics: {
        A: [],
        B: [],
      },
      initiative: undefined,
      imageNo: {
        A: 0,
        B: 0,
      },
      knightBoxEffect: {
        A: undefined,
        B: undefined,
      },
      selectStatus: {
        mode: 'neutral',
      },
      cardStatusTmp: {
        A: [],
        B: [],
      },
      // {
      //     roomId: roomId,
      //     roomSubId: roomSubId,
      //     gameMode: gameMode,
      //     side: side, // B
      //     duelistA: duelistA,
      //     duelistAUserName: duelistAUserName,
      //     duelistADeck: duelistADeck,
      //     duelistB: duelistB,
      //     duelistBUserName: duelistBUserName,
      //     duelistBDeck: duelistBDeck,
      //     status: duelStatus,
      //     serverTime: now.getTime(),
      // },
    },
    user: {},
    session: {},
    assetInfo: {},
    monacard: {},
    registeredCard: {},
    deckSet: {},
    deck: {
      height: null,
      displayDeck: true,
    },
    purchasePoint: {
      purchaseNo: null,
      addressMain: '',
      addressPayFrom: '',
      amountToBuy: 800,
      signatureByAddressMain: '',
      signatureByAddressPayFrom: '',
      disabled: false,
      status: 'waitingForSignature',
    },
    getPointHistory: {
      addressMain: '',
      action: 'point' ,
      lastEvaluatedKey: {
        point: [],
      },
      pagingIndex: {
        point: 0,
      }
    },
    getDuelHistory: {
      action: 'duelHistoryAll' ,
      lastEvaluatedKey: {
        duelHistoryAll: [],
        duelHistoryAddress: [],
        duelHistorySingle: [], // 使わないけど、nullを受けるために必要。
      },
      pagingIndex: {
        duelHistoryAll: 0,
        duelHistoryAddress: 0,
        duelHistorySingle: 0,
      },
      lastEvaluatedKey2: {
        duelHistoryAll: [], // 使わないけど、nullを受けるために必要。
        duelHistoryAddress: [],
        duelHistorySingle: [], // 使わないけど、nullを受けるために必要。
      },
      duelistAddress: undefined,
      roomId: undefined,
      duelNo: undefined,
      round: 0,
    },
    getDuelRanking: {
      action: {
        difficultyMode: 'advanced',
        gameMode: 'human',
        period: 'monthly',
      },
      lastEvaluatedKey: {
        simple: {
          human: {
            lifetime: [],
            monthly: [],
          },
          computer: {
            lifetime: [],
            monthly: [],
          },
        },
        advanced: {
          human: {
            lifetime: [],
            monthly: [],
          },
          computer: {
            lifetime: [],
            monthly: [],
          },
        },
      },
      pagingIndex: {
        simple: {
          human: {
            lifetime: 0,
            monthly: 0
          },
          computer: {
            lifetime: 0,
            monthly: 0
          },
        },
        advanced: {
          human: {
            lifetime: 0,
            monthly: 0
          },
          computer: {
            lifetime: 0,
            monthly: 0
          },
        },
      },
      lastRank: {
        simple: {
          human: {
            lifetime: [],
            monthly: [],
          },
          computer: {
            lifetime: [],
            monthly: [],
          },
        },
        advanced: {
          human: {
            lifetime: [],
            monthly: [],
          },
          computer: {
            lifetime: [],
            monthly: [],
          },
        },
      },
      records: {
        simple: {
          human: {
            lifetime: {},
            monthly: {},
          },
          computer: {
            lifetime: {},
            monthly: {},
          },
        },
        advanced: {
          human: {
            lifetime: {},
            monthly: {},
          },
          computer: {
            lifetime: {},
            monthly: {},
          },
        },
      },
    },
    getRegisteredItem: {
      action: 'registeredItemAll',
      lastEvaluatedKey: {
        registeredItemAll: [],
      },
      pagingIndex: {
        registeredItemAll: 0,
      },
    },
    searchDateRange: {
      from: {
        epoch: undefined, // new Date(yearLastMonth, monthLastMonth - 1, 1, 0, 0, 0, 0).getTime(),
        year: undefined, // yearLastMonth,
        month: undefined, // monthLastMonth,
        day: undefined, // 1, // now.getDate,
        hours: 0, // now.getHours,
        minutes: 0, // now.getMinutes,
        seconds: 0, // now.getSeconds,
        milliseconds: 0, // now.getMilliseconds,
      },
      to: {
        epoch: undefined, // new Date(yearLastMonth, monthLastMonth - 1, dayEndLastMonth, 23, 59, 59, 999).getTime(),
        year: undefined, // yearLastMonth,
        month: undefined, // monthLastMonth,
        day: undefined, // dayEndLastMonth,
        hours: 23,
        minutes: 59,
        seconds: 59,
        milliseconds: 999,
      },
    },
    notification: {
      body: [ '' ],
      index: 0,
      fixed: false,
      inAnimation: false,
    },
    notificationPersistent: {
      message: null,
      visible: false,
    },
    popup: [
      { type: null, body: null },
      { type: null, body: null },
      { type: null, body: null },
      { type: null, body: null },
    ],
    accessing: false,
    pointHistory: {},
    itemOrderHistory: {},
    pointSum: {},
    duelHistoryAll: {},
    duelHistoryAddress: {},
    duelHistorySingle: {},
    duelRankingAll: {},
    registeredItemAll: {},
    clock: undefined,
    addressCheck: 'strict',
    cardRegistration: {
      asset: '',
      name: '',
      feature: '',
      attribute: '',
      contact: '',
      mailAddress: '',
    },
    creatorInformation: {
    },
    animation: {
      youWinMona: 'visible',
    },
    knightBoxEffectPieces: {
      A: [],
      B: [],
    },
    checkout: {
      itemsIncart: {},
      addressMain: '',
      mailAddress: '',
      paymentMethod: 'paygent',
    },
    getItemOrderHistory: {
      addressMain: '',
      action: 'itemOrder' ,
      lastEvaluatedKey: {
        itemOrder: [],
      },
      pagingIndex: {
        itemOrder: 0,
      }
    },
    displaySecret: {
      mnemonic: '',
      mnemonicHidden: '',
      wif: '',
      address: '',
      swapMnemonics: '',
      mnemonicToWif: '',
      wifFromMnemonic: '',
    },
    walletType: initialWalletType({ walletTypeParam: urlParams.get('wallettype') }),
    qrCodeScanner: {
      qrCode: undefined,
    },
    headerFooterPosition: 'fixed',
    localSettingsCommon: {
      appSoundSwitch: 'on',
      collectibleWordSound: 'always',
    },
    activation: {
      addressMainEncrypted: '',
    },
    activationList: {
      action: 'activationHistoryAll' ,
      lastEvaluatedKey: {
        activationHistoryAll: [],
        activationHistoryAddressMainEncrypted: [],
      },
      pagingIndex: {
        activationHistoryAll: 0,
        activationHistoryAddressMainEncrypted: 0,
      },
      // lastEvaluatedKey2: {
      //   activationHistoryAll: [], // 使わないけど、nullを受けるために必要。
      //   activationHistoryAddressMainEncrypted: [],
      // },
      addressMainEncrypted: undefined,
      activationHistoryAll: {},
      activationHistoryAddressMainEncrypted: {},
    },
    challengeDuel: {
      designatedAddressesCsv: '',
      gameOption: {
        straightMan: {
          type: 'none',
        },
      },
    },
    makeUrlToBroadcast: {
      addressMain: null,
      addressOperator: null,
      clientTime: null,
      signature: null,
      connectionMatchingId: null,
      url: null,
    },
    keyPairs: {},
    subAddresses: {},
    passkey: {
      busy: false,
    },
    unregisteredAddress: {
      address: '',
    },
    savePasswordEncryptedMnemonic: {
      password: '',
      passwordExpressionType: 'kana',
      wordCount: '5',
    },
    loadPasswordEncryptedMnemonic: {
      password: '',
    },
  }

  const [state, dispatch] = useReducer(reducer, initialState);
  const navigate = useNavigate();
  // const [cookies, setCookie, removeCookie] = useCookies();
  // GlobalState = React.createContext([state, dispatch, navigate, cookies, setCookie, removeCookie]);

  useEffect( () => {
    const func = async () => {
      // AppConnect対応
      window.monapaletteConnect.getAddress().then(() => window.mpurse = window.monapaletteConnect).catch(() => {});

      // カメラある？

      hasCamera().then((hasCamera) => {
        dispatch({ type: 'setStateMultiLayers', keys: ['device', 'hasCamera'], value: hasCamera });
        devLog('has camera; ', hasCamera);
      });

      // 各種設定値取得
      // devLog('mainaddress', urlParams.get('mainaddress'));

      // -- cookie情報取得
      // if (cookies.addressCheck !== undefined) {
      //   dispatch({ type: 'setState', key: 'addressCheck', value: cookies.addressCheck });
      // }

      // dispatch({ type: 'setState', key: 'accessing', value: true });

      // const configKeys = ['clientParameters', 'monatokaPointParameters', 'initialNotification', 'blockbook'];
      const configKeys = ['clientParameters'];
      getConfig(dispatch, 'KnightsOfMonadom', configKeys , 'config');

      const configKeysMP = ['clientParameters'];
      getConfig(dispatch, 'monatokaPoint', configKeysMP , 'configMP');

      const configKeysKB = ['clientParameters'];
      getConfig(dispatch, 'keybox', configKeysKB , 'configKB');

      const [
        collectibleWordSoundRecord,
        appSoundSwitchRecord,
      ] = await Promise.all([
        getCompositeRecordFromIndexedDb({
          dbName: 'knightsOfMonadom',
          storeName: 'localSettingsCommon',
          keyFields: ['id'],
          keySource: { id: 'collectibleWordSound' },
        }),
        getCompositeRecordFromIndexedDb({
          dbName: 'knightsOfMonadom',
          storeName: 'localSettingsCommon',
          keyFields: ['id'],
          keySource: { id: 'appSoundSwitch' },
        }),
      ]);

      if (collectibleWordSoundRecord) {
        dispatch({
          type: 'setStateMultiLayers',
          keys: ['localSettingsCommon', 'collectibleWordSound'],
          value: collectibleWordSoundRecord.value,
        });
      }

      if (appSoundSwitchRecord) {
        dispatch({
          type: 'setStateMultiLayers',
          keys: ['localSettingsCommon', 'appSoundSwitch'],
          value: appSoundSwitchRecord.value,
        });
      }

      // 初期通知表示
      // dispatch({ type: 'setStateMultiLayers', keys: ['notification', 'body', 0], value: config.body.initialNotification.value });

      // -- 登録カード情報取得

      getRegisteredCard(state, dispatch);

      // dispatch({ type: 'setState', key: 'accessing', value: false });

      // devLog('domain', document.domain);
      // console.log('domain', document.domain);
      // console.log('MONA', JSON.stringify(networkMona));
    };

    func();
  }, []);

  let bottomUp;

  if (wallet === 'MonaPallet') {
    bottomUp =
    <div className="appConnectBottomUp">
    </div>;
  }

  const value = useMemo(
    () => ({ state, dispatch, navigate }),
    [state, dispatch, navigate]
  );

  return (
    <GlobalStateCS.Provider value={value}>
      <div className="App">
        <Routes>
          {/* <Route exact path={ process.env.REACT_APP_ENVIRONMENT === 'dev' ? '/build/' : '/'} element={<LP />} /> */}
          {/* <Route exact path={ process.env.REACT_APP_ENVIRONMENT === 'dev' ? '/build/index.html' : '/index.html'} element={<LP />} /> */}
          <Route exact path={ process.env.REACT_APP_ENVIRONMENT === 'dev' ? '/build/' : '/'} element={<Top />} />
          <Route exact path={ process.env.REACT_APP_ENVIRONMENT === 'dev' ? '/build/index.html' : '/index.html'} element={<Top />} />
          <Route exact path={ process.env.REACT_APP_ENVIRONMENT === 'dev' ? '/build/top' : '/top'} element={<Top />} />
          <Route exact path={ process.env.REACT_APP_ENVIRONMENT === 'dev' ? '/build/builddecks' : '/builddecks'} element={<BuildDeck />} />
          <Route exact path={ process.env.REACT_APP_ENVIRONMENT === 'dev' ? '/build/duel' : '/duel'} element={<Duel gameMode='human' difficultyMode='simple' />} />
          <Route exact path={ process.env.REACT_APP_ENVIRONMENT === 'dev' ? '/build/dueladvanced' : '/dueladvanced'} element={<Duel gameMode='human' difficultyMode='advanced' />} />
          <Route exact path={ process.env.REACT_APP_ENVIRONMENT === 'dev' ? '/build/duelcom' : '/duelcom'} element={<Duel gameMode='computer' difficultyMode='simple' />} />
          <Route exact path={ process.env.REACT_APP_ENVIRONMENT === 'dev' ? '/build/duelcomadvanced' : '/duelcomadvanced'} element={<Duel gameMode='computer' difficultyMode='advanced' />} />
          <Route exact path={ process.env.REACT_APP_ENVIRONMENT === 'dev' ? '/build/chargepoints' : '/chargepoints'} element={<ChargePoint />} />
          <Route exact path={ process.env.REACT_APP_ENVIRONMENT === 'dev' ? '/build/cardregistration' : '/cardregistration'} element={<CardRegistration />} />
          <Route exact path={ process.env.REACT_APP_ENVIRONMENT === 'dev' ? '/build/cardlist' : '/cardlist'} element={<CardList />} />
          <Route exact path={ process.env.REACT_APP_ENVIRONMENT === 'dev' ? '/build/playerstats' : '/playerstats'} element={<PlayerStats />} />
          <Route exact path={ process.env.REACT_APP_ENVIRONMENT === 'dev' ? '/build/duelhistory' : '/duelhistory'} element={<DuelHistory />} />
          <Route exact path={ process.env.REACT_APP_ENVIRONMENT === 'dev' ? '/build/duelhistorydetail' : '/duelhistorydetail'} element={<DuelHistoryDetailFullScreen />} />
          <Route exact path={ process.env.REACT_APP_ENVIRONMENT === 'dev' ? '/build/duelranking' : '/duelranking'} element={<DuelRanking />} />
          <Route exact path={ process.env.REACT_APP_ENVIRONMENT === 'dev' ? '/build/purchaseitems' : '/purchaseitems'} element={<PurchaseItem />} />
          <Route exact path={ process.env.REACT_APP_ENVIRONMENT === 'dev' ? '/build/itemorderhistory' : '/itemorderhistory'} element={<ItemOrderHistory />} />
          <Route exact path={ process.env.REACT_APP_ENVIRONMENT === 'dev' ? '/build/checkout' : '/checkout'} element={<CheckOut />} />
          <Route exact path={ process.env.REACT_APP_ENVIRONMENT === 'dev' ? '/build/setting' : '/setting'} element={<Setting />} />
          <Route exact path={ process.env.REACT_APP_ENVIRONMENT === 'dev' ? '/build/nfc-callback' : '/nfc-callback'} element={<NfcCallback />} />
          <Route exact path={ process.env.REACT_APP_ENVIRONMENT === 'dev' ? '/build/aboutknightsofmonadom' : '/aboutknightsofmonadom'} element={<AboutKnightsOfMonadom />} />
          <Route exact path={ process.env.REACT_APP_ENVIRONMENT === 'dev' ? '/build/retailer' : '/retailer'} element={<Retailer />} />
          <Route exact path={ process.env.REACT_APP_ENVIRONMENT === 'dev' ? '/build/livetext' : '/livetext'} element={<LiveText />} />
        </Routes>
        { bottomUp }
        {/* popup */}
        <Popup layer={0}/>
        <Popup layer={1}/>
        <Popup layer={2}/>
        <Popup layer={3}/>
        <Popup layer={4}/>
        <Popup layer={101}/>
        <Popup layer={102}/>
        <Popup layer={103}/>
        <Popup layer={104}/>
        <NotificationFadingOut />
        <RollingMagic />
      </div>
    </GlobalStateCS.Provider>
  );
}

// CHALLENGE DUEL POPUP
function ChallengeDuelPopup(props) {
  const state = useGlobalStateSelector(({ state }) => state);
  const dispatch = useGlobalStateSelector(({ dispatch }) => dispatch);
  const navigate = useGlobalStateSelector(({ navigate }) => navigate);
  const popupLayer = props.popupLayer;
  const handleClickChallengeDuelButton = ({ gameMode, difficultyMode, popupLayer }) => {
    ensureUnlockAudio();

    handleClickChallengeDuel({ navigate, gameMode, difficultyMode });
    dispatch({ type: 'setStateMultiLayers', keys: ['popup', popupLayer], value: { type: null, body: null } });
  };

  const onButton =
  <button className='buttonMainColor widthMin20 heightMin4 flexColumn justifyContentCenter alignItemsCenter '
    onClick={ () => {
      dispatch({ type: 'setStateMultiLayers', keys: ['challengeDuel', 'gameOption', 'straightMan', 'type'], value: 'normal' }); 
      dispatch({ type: 'setStateMultiLayers', keys: ['popup', popupLayer + 1], value: { type: null, body: null } }); 
    }}
  >
    <div>
      { words.onAri[state.language] }
    </div>
  </button>;

  const offButton =
  <button className='buttonMainColor widthMin20 heightMin4 flexColumn justifyContentCenter alignItemsCenter '
    onClick={ () => {
      dispatch({ type: 'setStateMultiLayers', keys: ['challengeDuel', 'gameOption', 'straightMan', 'type'], value: 'none' }); 
      dispatch({ type: 'setStateMultiLayers', keys: ['popup', popupLayer + 1], value: { type: null, body: null } }); 
    }}
  >
    <div>
      { words.offNashi[state.language] }
    </div>
  </button>

  const straightManPopup =
  <div className='flexRow alignItemsCenter ' >
    { onButton }
    { offButton }
  </div>;

  const straightManPopupSp =
  <div className='flexColumn alignItemsCenter ' >
    { onButton }
    { offButton }
  </div>;

  let straightManStatusWord;

  if (state.challengeDuel.gameOption.straightMan.type !== 'none') {
    straightManStatusWord = words.onAri[state.language];
  }
  else {
    straightManStatusWord = words.offNashi[state.language];
  }


  return (
    <div>
      <div className="visibleMiddleOrMore ">
        <div className="flexColumn alignItemsFlexStart ">
          <div className='flexRow justifyContentCenter alignItemsCenter ' >
            <button className='buttonMainColor widthMin20 heightMin4 flexColumn justifyContentCenter alignItemsCenter '
              onClick={ () => {
                handleClickChallengeDuelButton({ gameMode: 'human', difficultyMode: 'advanced', popupLayer: popupLayer });
              }}
            >
              <div>
                { words.duelAgainstHuman[state.language] }
              </div>
              <div>
                { `(${words.advancedMode[state.language]})` }
              </div>
            </button>
            <button className='buttonMainColor widthMin20 heightMin4 flexColumn justifyContentCenter alignItemsCenter '
              onClick={ () => {
                handleClickChallengeDuelButton({ gameMode: 'computer', difficultyMode: 'advanced', popupLayer: popupLayer });
              }}
            >
              <div>
                { words.duelAgainstComputer[state.language] }
              </div>
              <div>
                { `(${words.advancedMode[state.language]})` }
              </div>
            </button>
            <button className='buttonMainColor widthMin20 heightMin4 flexColumn justifyContentCenter alignItemsCenter '
              onClick={ () => {
                handleClickChallengeDuelButton({ gameMode: 'human', popupLayer: popupLayer });
              }}
            >
              <div>
                { words.duelAgainstHuman[state.language] }
              </div>
              <div>
                { `(${words.simpleMode[state.language]})` }
              </div>
            </button>
            <button className='buttonMainColor widthMin20 heightMin4 flexColumn justifyContentCenter alignItemsCenter '
              onClick={ () => {
                handleClickChallengeDuelButton({ gameMode: 'computer', popupLayer: popupLayer });
              }}
            >
              <div>
                { words.duelAgainstComputer[state.language] }
              </div>
              <div>
                { `(${words.simpleMode[state.language]})` }
              </div>
            </button>
          </div>
          <div className='flexRow justifyContentFlexStart alignItemsFlexStart ' >
            <div className='flexColumn margin0p5 ' >
              <div className='margin0p5 ' >
                { words.opponentAddressOptional[state.language] }
              </div>
              <TextArea2
                fieldName='challengeDuelDesignatedAddressesCsv'
                keys={['challengeDuel', 'designatedAddressesCsv']}
                face=''
                boxClass='box4 width32 margin1'
                textAreaClass='textArea1'
              />
            </div>
            <div className='flexColumn margin0p5 ' >
              <div className='margin0p5 ' >
                { `${words.tsukkomiOption[state.language]}(${words.plus100Points[state.language]})` }
              </div>
              <button className={'box3 focusEffect01 riseOut2 ' + (state.challengeDuel.gameOption.straightMan.type !== 'none' ? 'colorRed borderSelected' : 'borderNone')}
                tabindex='0'
                onClick={ () => {
                  const popup = { type: 'generalItems', body: straightManPopup };
                  dispatch({ type: 'setStateMultiLayers', keys: ['popup', popupLayer +1], value: popup });
                }}
              >
                { straightManStatusWord }
              </button>
            </div>
            <div className='flexColumn margin0p5 ' >
              <DuelSettingsButton popupLayer={popupLayer} />
            </div>
          </div>
        </div>
      </div>
      <div className="visibleSmallOrLess ">
        <div className='flexColumn justifyContentCenter alignItemsCenter ' >
          <button className='buttonMainColor widthMin20 heightMin4 flexColumn justifyContentCenter alignItemsCenter '
            onClick={ () => {
              handleClickChallengeDuelButton({ gameMode: 'human', difficultyMode: 'advanced', popupLayer: 0 });
            }}
          >
            <div>
              { words.duelAgainstHuman[state.language] }
            </div>
            <div>
              { `(${words.advancedMode[state.language]})` }
            </div>
          </button>
          <button className='buttonMainColor widthMin20 heightMin4 flexColumn justifyContentCenter alignItemsCenter '
            onClick={ () => {
              handleClickChallengeDuelButton({ gameMode: 'computer', difficultyMode: 'advanced', popupLayer: 0 });
            }}
          >
            <div>
              { words.duelAgainstComputer[state.language] }
            </div>
            <div>
              { `(${words.advancedMode[state.language]})` }
            </div>
          </button>
          <button className='buttonMainColor widthMin20 heightMin4 flexColumn justifyContentCenter alignItemsCenter '
            onClick={ () => {
              handleClickChallengeDuelButton({ gameMode: 'human', popupLayer: 0 });
            }}
          >
            <div>
              { words.duelAgainstHuman[state.language] }
            </div>
            <div>
              { `(${words.simpleMode[state.language]})` }
            </div>
          </button>
          <button className='buttonMainColor widthMin20 heightMin4 flexColumn justifyContentCenter alignItemsCenter '
            onClick={ () => {
              handleClickChallengeDuelButton({ gameMode: 'computer', popupLayer: 0 });
            }}
          >
            <div>
              { words.duelAgainstComputer[state.language] }
            </div>
            <div>
              { `(${words.simpleMode[state.language]})` }
            </div>
          </button>
          <div className='marginTop1 marginBottom0p5 ' >
            { words.opponentAddressOptional[state.language] }
          </div>
          <TextArea2
            fieldName='challengeDuelDesignatedAddressesCsv'
            keys={['challengeDuel', 'designatedAddressesCsv']}
            face=''
            boxClass='box4 width20 margin1'
            textAreaClass='textArea1'
          />
          <div className='marginTop1 marginBottom0p5 ' >
            { `${words.tsukkomiOption[state.language]}(${words.plus100Points[state.language]})` }
          </div>
          <button className={'box3 focusEffect01 riseOut2 ' + (state.challengeDuel.gameOption.straightMan.type !== 'none' ? 'colorRed borderSelected' : 'borderNone')}
            tabindex='0'
            onClick={ () => {
              const popup = { type: 'generalItems', body: straightManPopupSp };
              dispatch({ type: 'setStateMultiLayers', keys: ['popup', popupLayer +1], value: popup });
            }}
          >
            { straightManStatusWord }
          </button>
          <div className='marginTop1 marginBottom0p5 '>
            <DuelSettingsButton popupLayer={popupLayer} />
          </div>
        </div>
      </div>
    </div>
  );
}

// POPUP
function Popup(props) {
  const state = useGlobalStateSelector(({ state }) => state);
  const dispatch = useGlobalStateSelector(({ dispatch }) => dispatch);

  const popup = state.popup[props.layer];

  const popupComponent = {
    generalList: <GeneralList popupLayer={props.layer} />,
    generalItems: <GeneralItems popupLayer={props.layer} />,
    pointRecordDetail: <PointRecordDetail popupLayer={props.layer} />,
    monsterDetail: <MonsterDetail popupLayer={props.layer} />,
    duelHistoryDetail: <DuelHistoryDetail popupLayer={props.layer} />,
    // selectActionBox: <SelectActionBox popupLayer={props.layer} />,
    itemDetailSP: <ItemDetailSP popupLayer={props.layer} />,
    // itemDetailMore: <ItemDetailMore popupLayer={props.layer} />,
    deckOnDuelSP: <DeckOnDuelSP popupLayer={props.layer} />,
    duelSettingsPopup: <DuelSettingsPopup popupLayer={props.layer} />,
    deckInHistorySP: <DeckInHistorySP popupLayer={props.layer} />,
    creatorInformation: <CreatorInformation popupLayer={props.layer} />,
    itemOrderHistoryRecordDetail: <ItemOrderHistoryRecordDetail popupLayer={props.layer} />,
    merchandiseDetail: <MerchandiseDetail popupLayer={props.layer} />,
    challengeDuelPopup: <ChallengeDuelPopup popupLayer={props.layer} />,
    selectSessionPopup: <SelectSessionPopup popupLayer={props.layer} />,
    displayQrPopup: <DisplayQrPopup popupLayer={props.layer} />,
    displayWifPopup: <DisplayWifPopup popupLayer={props.layer} />,
    userRegistrationPopup: <UserRegistrationPopup popupLayer={props.layer} />,
    readMnemonicForRegistrationPopup: <ReadMnemonicForRegistrationPopup popupLayer={props.layer} />,
    readWifForRegistrationPopup: <ReadWifForRegistrationPopup popupLayer={props.layer} />,
    mnemonicInputPopup: <MnemonicInputPopup popupLayer={props.layer} />,
    wifInputPopup: <WifInputPopup popupLayer={props.layer} />,
    confirmMnemonicPopup: <ConfirmMnemonicPopup popupLayer={props.layer} />,
    confirmationPopup: <ConfirmationPopup popupLayer={props.layer} />,
    registrationAndAgreementListPopup: <RegistrationAndAgreementListPopup popupLayer={props.layer} />,
    selectSubAddressPopup: <SelectSubAddressPopup popupLayer={props.layer} />,
    selectAddressFromKeypoolPopup: <SelectAddressFromKeypoolPopup popupLayer={props.layer} />,
    qrCodeScannerPopup: <QrCodeScannerPopup popupLayer={props.layer} />,
    selectSecretPopup: <SelectSecretPopup popupLayer={props.layer} />,
    qrCodeReaderPopup: <QrCodeReaderPopup popupLayer={props.layer} />,
  };

  if (state.popup[props.layer]?.type === undefined || state.popup[props.layer].type === null) {
    return (
      <div className='invisible' />
    );
  }
  else {
    return (
      <div>
        {/* PC */}
        <div className="visibleMiddleOrMore">
          <div className={'popupBackgroundMultiLayer' + (popup.extendedClassesBackGround !== undefined ? ' ' + popup.extendedClassesBackGround : '')} style={{ '--popupLayer': props.layer }}>
            <button className='closePopupMultiLayer' style={{ '--popupLayer': props.layer }}
              onClick={ () => dispatch({ type: 'setStateMultiLayers', keys: ['popup', props.layer], value: { type: null, body: null } }) }
            />
            <div className='popupMultiLayer' style={{ '--popupLayer': props.layer }}>
              <button className='topRightClose font2 focusEffect01' tabindex='0'
                onClick={ () => dispatch({ type: 'setStateMultiLayers', keys: ['popup', props.layer], value: { type: null, body: null } }) } 
              >
                ×
              </button>
              {popupComponent[state.popup[props.layer].type]}
            </div>
          </div>
        </div>
        {/* SP */}
        <div className="visibleSmallOrLess">
          <div className='popupBackgroundMultiLayer' style={{ '--popupLayer': props.layer }}>
            <button className='closePopupMultiLayer' style={{ '--popupLayer': props.layer }}
              onClick={ () => dispatch({ type: 'setStateMultiLayers', keys: ['popup', props.layer], value: { type: null, body: null } }) }
            />
            <div className='popupMultiLayerSmallScreen ' style={{ '--popupLayer': props.layer }}>
              <button className='topRightClose font2 focusEffect01' tabindex='0'
                onClick={ () => dispatch({ type: 'setStateMultiLayers', keys: ['popup', props.layer], value: { type: null, body: null } }) } 
              >
                ×
              </button>
              {popupComponent[state.popup[props.layer].type]}
            </div>
          </div>
        </div>
      </div>
    );
  }
  // else {
  //   return (
  //     <div className='' >
  //     </div>
  //   );
  // }
}


// GENERAL LIST
function GeneralList(props) {
  const state = useGlobalStateSelector(({ state }) => state);
  const body = state.popup[props.popupLayer].body;

  return (
    <div className=''>
      {/* PC */}
      <div className='visibleMiddleOrMore flexColumn alignItemsCenter'>
        <div className='flexColumn alignItemsCenter'>
          { body.title }
        </div>
        <div className='flexColumn alignItemsCenter'>
          { body.options }
        </div>
      </div>
      {/* SP */}
      <div className='visibleSmallOrLess flexColumn widthMax'>
        <div className='flexColumn alignItemsCenter widthMax'>
          { body.title }
        </div>
        <div className='flexColumn alignItemsCenter widthMax'>
          { body.options }
        </div>
      </div>
    </div>
  );
}

// GENERAL ITEMS
function GeneralItems(props) {
  const state = useGlobalStateSelector(({ state }) => state);
  const body = state.popup[props.popupLayer].body;

  return (
    <div className='flexColumn alignItemsCenter'>
      { body }
    </div>
  );
}

// GENERAL OPTION
// eslint-disable-next-line no-unused-vars
function GeneralOption(props) {
  const dispatch = useGlobalStateSelector(({ dispatch }) => dispatch);
  const record = props.record;
  const recordKey = props.recordKey;
  const sortedKeys = props.sortedKeys;
  const stateKeys = props.stateKeys;
  const onSelect = props.onSelect;
  const layer = props.layer;
  let value;

  if (Object.keys(record).length === 1) {
    if (Object.values(record)[0].value !== undefined) {
      value = Object.values(record)[0].value;
    }
    else {
      value = Object.keys(record)[0];
    }
  }
  else {
    if (record[recordKey].value !== undefined) {
      value = record[recordKey].value;
    }
    else {
      value = recordKey;
    }
  }

  const factors = sortedKeys.map( key => {
    if (record[key].face !== undefined) {
      return <div className={record[key].style} >
        { record[key].face }
      </div>;
    }
    else {
      return <div className={record[key].style} >
        { key }
      </div>;
    }
  });


  return (
    <div className=''>
      {/* PC */}
      <button className='visibleMiddleOrMore boxMonacotto1 margin0p5 cursor riseOut2'
        onClick={ () => {
          if (onSelect !== undefined) {
            onSelect(value);
          }
          else {
            dispatch({ type: 'setStateMultiLayers', keys: stateKeys, value: value });
          }
          dispatch({ type: 'setStateMultiLayers', keys: ['popup', layer], value: { type: null, body: null } });
        }} 
      >
        { factors }
      </button>
      {/* SP */}
      <button className='visibleSmallOrLess boxMonacotto1SmallScreen cursor riseOut2'
        onClick={ () => {
          if (onSelect !== undefined) {
            onSelect(value);
          }
          else {
            dispatch({ type: 'setStateMultiLayers', keys: stateKeys, value: value });
          }
          dispatch({ type: 'setStateMultiLayers', keys: ['popup', layer], value: { type: null, body: null } });
        }} 
      >
        { factors }
      </button>
    </div>
  );
}

// TEXT AREA MULTI LAYERS STATE
function TextArea2(props) {
  const state = useGlobalStateSelector(({ state }) => state);
  const dispatch = useGlobalStateSelector(({ dispatch }) => dispatch);
  const value = props.keys.reduce( (acc, cur) => { return acc[cur]; }, state );
  const type = props.type !== undefined ? props.type : 'setStateMultiLayers';

  return (
    <div className={'flexColumn alignItemsCenter ' + props.outerClass}>
            <input className='invisibleCheckBox' id={'UVCB_' + props.fieldName + 'Background'} type='checkbox' />
            <div className={props.boxClass}>
              <textarea className={props.textAreaClass} value={value}
                onFocus={ () => {
                  document.getElementById('UVCB_' + props.fieldName + 'Background').checked=true; 
                  document.getElementById('UVCB_' + props.fieldName + 'Label').checked=true; 
                }}
                onBlur={ () => {
                  document.getElementById('UVCB_' + props.fieldName + 'Background').checked=false; 
                  document.getElementById('UVCB_' + props.fieldName + 'Label').checked=false; 
                }}
                onChange={ (e) => {
                  dispatch({type: type, keys: props.keys, value: e.target.value});
                }}
              />
              <input className='invisibleCheckBox' id={'UVCB_' + props.fieldName + 'Label'} type='checkbox' />
              <div className={ value === '' ? 'label1Unfilled' : 'label1Filled'}>
                {props.face}
              </div>
            </div>
    </div>
  );
}

// NOTIFICATION FADING OUT
function NotificationFadingOut() {
  const state = useGlobalStateSelector(({ state }) => state);
  const dispatch = useGlobalStateSelector(({ dispatch }) => dispatch);

  useEffect( () => {
    return () => {
      dispatch({ type: 'stopNotificationAnimation', key: 'notification' });
    };
  }, []);

  return (
    <CSSTransition in={state.notification.inAnimation} timeout={5000} classNames="messageFade"
      onEntered={ () => {
                    dispatch({ type: 'stopNotificationAnimation', key: 'notification' });
                  }
               }
    >
      <div className={state.notification.inAnimation ? 'maxWidth98vw' : 'invisible'} >
          { state.notification.body[state.notification.index] }
      </div>
    </CSSTransition>
  );
}

// ROLLING MAGIC
function RollingMagic() {
  const state = useGlobalStateSelector(({ state }) => state);

  let magic;

  if (state.accessing) {
    magic = <div className='magicRollingCenter' />;
  }
  else {
    magic = null;
  }

  return (
    <div>
      { magic }
    </div>
  );
}

// ---------------------------


// GET REGISTERED CARD
async function getRegisteredCard(state, dispatch) {
  let request = {};
  let messages = {};
  const registeredCardsIndex = {};

  // state固定
  // const stateFixed = {
  // };

  request.body = JSON.stringify({
    "body": {
    }
  });

  request.url = 'https://' + process.env.REACT_APP_KOM_API_DOMAIN + '/get_registered_card';
  request.method = 'POST';

  messages = {
  };

  const response = await syncHttpRequest2(request, undefined, undefined, undefined, messages, dispatch);

  if ( response.status === 'rejected' ) {
    return {
      status: 'rejected',
    };
  }

  for (const registeredCard of response.body) {
    registeredCardsIndex[registeredCard.asset] = registeredCard;
  }

  dispatch({ type: 'setState', key: 'registeredCard', value: registeredCardsIndex });
  devLog('registeredCard', JSON.stringify(registeredCardsIndex));

  return {
    status: 'fulfilled',
    body: registeredCardsIndex,
  };
}


async function getConfig(dispatch, project, keys, stateKey) {
  let request = {};
  let messages = {};

  request.body = JSON.stringify({
    body: {
      project: project,
      keys: keys,
    }
  });

  request.url = 'https://' + process.env.REACT_APP_KOM_API_DOMAIN + '/get_client_parameter';
  request.method = 'POST';

  messages = {
  };

  const response = await syncHttpRequest2(request, stateKey, undefined, undefined, messages, dispatch);

  if ( response.status === 'fulfilled' ) {
    return {
      status: 'fulfilled',
      body: response,
    };
  }
  else {
    return {
      status: 'rejected',
    };
  }
}

function applyStateMultiLayers(newState, keys, value) {
  if (!Array.isArray(keys) || keys.length === 0) {
    return false;
  }

  const isIndexKey = (key) => {
    if (typeof key === 'number') return Number.isInteger(key) && key >= 0;
    if (typeof key === 'string') return /^[0-9]+$/.test(key);
    return false;
  };

  keys.reduce((acc, cur, idx) => {
    const isLast = idx === keys.length - 1;
    if (isLast) {
      acc[cur] = value;
      return acc[cur];
    }
    const currentValue = acc[cur];
    const nextKey = keys[idx + 1];
    let nextLayer;

    if (Array.isArray(currentValue)) {
      nextLayer = [...currentValue];
    }
    else if (currentValue && typeof currentValue === 'object') {
      nextLayer = { ...currentValue };
    }
    else if (isIndexKey(nextKey)) {
      nextLayer = [];
    }
    else {
      nextLayer = {};
    }

    acc[cur] = nextLayer;
    return nextLayer;
  }, newState);

  return true;
}

// REDUCER
function reducer(state, action) {
  let newState = { ...state };
  // let numericCharacter;
  // let number;
  // let isChanged;
  // let items;
  // let item;
  // let newIndex;

  switch (action.type) {
    case 'setState': {
      newState[action.key] = action.value;
      return newState;
    }

    case 'setStateMultiLayers': {
      if (!applyStateMultiLayers(newState, action.keys, action.value)) {
        return state;
      }

      return newState;
    }

    case 'setStateMultiLayersAtomic': {
      if (!Array.isArray(action.updates) || action.updates.length === 0) {
        return state;
      }

      for (const update of action.updates) {
        if (!applyStateMultiLayers(newState, update.keys, update.value)) {
          return state;
        }
      }

      return newState;
    }

    case 'updateUserCollectibleWordsFromBattleUp': {
      const userRecord = state.user[action.addressMain];

      if (userRecord === undefined) {
        return state;
      }

      const collectibleWordSoundEffectNamesInBattle = buildCollectibleWordSoundEffectNamesInBattle({
        result: action.result,
        collectibleWords: userRecord.collection?.collectibleWords ?? [],
        collectibleWordSoundEffectNamesInDuel: state.duel.collectibleWordSoundEffectNamesInDuel,
      });
      const collectibleWordSoundEffectNamesInDuel = buildCollectibleWordSoundEffectNamesInDuel({
        collectibleWordSoundEffectNamesInDuel: state.duel.collectibleWordSoundEffectNamesInDuel,
        collectibleWordSoundEffectNamesInBattle,
      });

      newState.duel = {
        ...state.duel,
        collectibleWordSoundEffectNamesInDuel,
        collectibleWordSoundEffectNamesInBattle,
      };

      newState.user = {
        ...state.user,
        [action.addressMain]: buildUserWithCollectibleWordsFromBattleUp({
          userRecord,
          result: action.result,
          previousResults: state.duel.result,
          roomId: action.roomId,
          duelNo: action.duelNo,
          round: action.round,
          language: action.language,
        }),
      };

      return newState;
    }

    // case 'setStateMultiLayers':
    //   action.keys.concat([action.value]).reduce( (acc, cur, idx, src) => {
    //     if (idx === src.length - 1) {
    //       return acc;
    //     }
    //     if (idx === src.length - 2) {
    //       return acc[cur] = src[idx + 1];
    //     }
    //     else {
    //       return acc[cur];
    //     }
    //   }, newState );
    //   return newState;

    case 'setStateNum': {
      const number = parseInt(action.value, 10);

      if (Number.isNaN(number)) {
        newState[action.key] = ''
      }
      else {
        newState[action.key] = number;
      }

      return newState;
    }

    case 'setStateMultiLayersNum': {
      let number = parseInt(action.value, 10);

      if (Number.isNaN(number)) {
        number = ''
      }

      action.keys.reduce( (acc, cur, idx, src) => {
        if (idx === src.length - 1) {
          return acc[cur] = number;
        }
        else {
          return acc[cur];
        }
      }, newState );

      return newState;
    }

    case 'setStateFloat': {
      const number = parseFloat(action.value);

      if (Number.isNaN(number)) {
        newState[action.key] = ''
      }
      else {
        newState[action.key] = number;
      }

      return newState;
    }

    case 'setStateMultiLayersFloat': {
      if (!Array.isArray(action.keys) || action.keys.length === 0) {
        return state;
      }

      const isIndexKey = (key) => {
        if (typeof key === 'number') return Number.isInteger(key) && key >= 0;
        if (typeof key === 'string') return /^[0-9]+$/.test(key);
        return false;
      };

      const faceSource = action.value === undefined || action.value === null ? '' : String(action.value);
      const numericCharacter = faceSource.replace(/[^\d.]/, '');
      let number = parseFloat(numericCharacter);

      if (Number.isNaN(number)) {
        number = ''
      }
      else if (action.adjustType !== undefined) {
        number = decimalAdjust(action.adjustType, number, action.adjustExp);
      }

      action.keys.reduce((acc, cur, idx) => {
        const isLast = idx === action.keys.length - 1;

        if (isLast) {
          const currentLeaf = acc[cur];
          let nextLeaf;

          if (currentLeaf && typeof currentLeaf === 'object' && !Array.isArray(currentLeaf)) {
            nextLeaf = { ...currentLeaf };
          }
          else {
            nextLeaf = {};
          }

          nextLeaf.face = numericCharacter;
          nextLeaf.value = number;

          acc[cur] = nextLeaf;
          return acc[cur];
        }

        const currentValue = acc[cur];
        const nextKey = action.keys[idx + 1];
        let nextLayer;

        if (Array.isArray(currentValue)) {
          nextLayer = [...currentValue];
        }
        else if (currentValue && typeof currentValue === 'object') {
          nextLayer = { ...currentValue };
        }
        else if (isIndexKey(nextKey)) {
          nextLayer = [];
        }
        else {
          nextLayer = {};
        }

        acc[cur] = nextLayer;
        return nextLayer;
      }, newState);

      return newState;
    }

    // // setStateMultiLayersFloat
    // case 'setStateMultiLayersFloat':
    //   numericCharacter = action.value.replace(/[^\d.]/, '');
    //   number = parseFloat(numericCharacter);

    //   if (Number.isNaN(number)) {
    //     number = ''
    //   }
    //   else if (action.adjustType !== undefined) {
    //     number = decimalAdjust(action.adjustType, number, action.adjustExp);
    //   }

    //   action.keys.reduce( (acc, cur, idx, src) => {
    //     if (idx === src.length - 1) {
    //       acc[cur].face = numericCharacter;
    //       acc[cur].value = number;
    //       return acc[cur];
    //     }
    //     else {
    //       return acc[cur];
    //     }
    //   }, newState );

    //   return newState;

    case 'setStateMultiLayersMasked': {
      if (!Array.isArray(action.keys) || action.keys.length === 0) {
        return state;
      }

      const isIndexKey = (key) => {
        if (typeof key === 'number') return Number.isInteger(key) && key >= 0;
        if (typeof key === 'string') return /^[0-9]+$/.test(key);
        return false;
      };

      action.keys.reduce((acc, cur, idx) => {
        const isLast = idx === action.keys.length - 1;

        if (isLast) {
          const currentLeaf = acc[cur];
          let nextLeaf;

          if (currentLeaf && typeof currentLeaf === 'object' && !Array.isArray(currentLeaf)) {
            nextLeaf = { ...currentLeaf };
          }
          else {
            nextLeaf = {};
          }

          nextLeaf.face = '*'.repeat(action.value ? action.value.length : 0);
          nextLeaf.value = action.value;

          acc[cur] = nextLeaf;
          return acc[cur];
        }

        const currentValue = acc[cur];
        const nextKey = action.keys[idx + 1];
        let nextLayer;

        if (Array.isArray(currentValue)) {
          nextLayer = [...currentValue];
        }
        else if (currentValue && typeof currentValue === 'object') {
          nextLayer = { ...currentValue };
        }
        else if (isIndexKey(nextKey)) {
          nextLayer = [];
        }
        else {
          nextLayer = {};
        }

        acc[cur] = nextLayer;
        return nextLayer;
      }, newState);

      return newState;
    }

    // adjustFace
    case 'adjustFace': {
      action.keys.reduce( (acc, cur, idx, src) => {
        if (idx === src.length - 1) {
          acc[cur].face = acc[cur].value;
          return acc[cur];
        }
        else {
          return acc[cur];
        }
      }, newState );

      return newState;
    }

    // pushOut
    case 'pushOut': {
      const target = action.targetKeys.reduce( (acc, cur) => {
          return acc[cur];
      }, newState );

      action.keys.reduce( (acc, cur, idx, src) => {
        const pushedOut = target[cur];
        target[cur] = acc;
        return  pushedOut;
      }, action.value );

      return newState;
    }

    case 'setStateIfChange': {
      if (newState[action.key] !== action.value) {
        newState[action.key] = action.value;
        return newState;
      }
      else {
        return state;
     }
    }

    case 'setStateMultiLayersIfChange': {
      const isChanged = action.keys.concat([action.value]).reduce( (acc, cur, idx, src) => {
        if (idx === src.length - 1) {
          return acc;
        }
        if (idx === src.length - 2) {
          if (acc[cur] !== src[idx + 1]) {
            acc[cur] = src[idx + 1];
            return true;
          }
          else {
            return false;
          }
        }
        else {
          return acc[cur];
        }
      }, newState );

      if (isChanged) {
        return newState;
      }
      else {
        return state;
      }
    }

    // setNotification
    case 'setNotification': {
      newState[action.key].body.push(action.value);

      if (newState[action.key].body.length > state.config.clientParameters.notificationMaxLength) {
        newState[action.key].body.shift();
      }

      newState[action.key].index = newState[action.key].body.length -1;

      newState[action.key].inAnimation = true;

      return newState;
    }

    case 'stopNotificationAnimation': {
      newState[action.key].inAnimation = false;
      return newState;
    }

    // itemReplace
    case 'itemReplace': {
      const items = newState.items[newState.gallery.addressMain].itemPlacement[0].items;
      const item = items[action.index];

      let newIndex;
      if (action.direction === 'left') {
        newIndex = action.index - 1 >= 0 ? action.index -1 : items.length - 1;
      }
      else { // right
        newIndex = action.index + 1 <= items.length - 1 ? action.index + 1 : 0;
      }

      items.splice(action.index, 1);
      items.splice(newIndex, 0, item);

      return newState;
    }

    // default
    default: {
      return state;
    }
  }
}

export default App;
